import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container"]

  connect() {
    // Nothing needed here for now
  }

  add(event) {
    event.preventDefault();
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now())
    const target = event.target.dataset.target || 'bottom';

    if (target == 'top') {
      this.containerTarget.insertAdjacentHTML("afterbegin", content)
    } else if (target == 'bottom') {
      this.containerTarget.insertAdjacentHTML("beforeend", content)
    }

  }

  remove(event) {
    event.preventDefault()
    const wrapper = event.target.closest(".nested-fields")
    const destroyInput = wrapper.querySelector("input[name*='_destroy']")

    if (destroyInput) {
      destroyInput.value = "1"
      wrapper.style.display = "none"
    } else {
      wrapper.remove()
    }
  }
}